module.exports = __webpack_public_path__ + "img/aw.aw5833f13.svg";